//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyHydrate from 'vue-lazy-hydration';
import { onSSR } from '@vue-storefront/core';
import { useArtcleOne } from '@bee-hole/coms';
import { ref, computed, useRoute, onMounted } from '@nuxtjs/composition-api';
import { useCache } from '@bee-hole/cache';
export default {
  components: {
    LazyHydrate
  },
  transition: 'fade',
  head() {
    return {
      title: this?.Artcle?.title + ' - ' + this?.configs?.title
    };
  },
  layout({ app }) {
    return app?.$storeConfig?.mall_home_type || 'default';
  },
  setup(props, context) {
    const loading = ref(false);
    const { articleOneGet, artcle } = useArtcleOne('ArticleInfo');
    const route = useRoute();
    const articleId = ref(route.value?.params?.id);
    const ahtml = ref();
    const configs = computed(() => context?.root?.$options?.$mallConfig?.mall_web_config);
    const markedGet = (val) => {
      if (val) {
        return (val);
      } else {
        return '';
      }
    };
    const bgColor = computed(() => {
      if (context?.root.$options.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        return config?.bgColor || '#09194c';
      } else {
        return '#fff';
      }

    });
    const fontColor = computed(() => {
      if (context?.root.$options.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        return config?.fontColor || '#ffffff';
      } else {
        return '#000';
      }
    });

    const { addTags } = useCache();
    onSSR(async () => {
      await articleOneGet({ article_id: articleId.value });
      if (!artcle?.value) {
        context.root?.$nuxt?.error({ statusCode: 404, title: 'article_null', description: 'article_null' });
      } else {
        try {
          addTags([
            { prefix: "A", value: articleId.value, dataPrefix: context.root.$options?.$storeConfig?.mall_cache_pre }
          ]);
        } catch (e) {
          console.log(e);
        }
      }
    });
    onMounted(() => {
      try {
        if (loading.value) {
          return false;
        }
        loading.value = true;
        // 通过ref获取到所有有usemap的dom元素
        const imgs = ahtml.value?.querySelectorAll('img[usemap]');
        // 通过遍历所有的dom元素，通过usemap的值获取到对应的map元素
        imgs?.forEach((img, index) => {
          // 获取img元素的height和width
          const alt = img.getAttribute('alt');
          if (index !== -1 && alt.indexOf('autosize1') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            // const imgWidth = img.width;
            // const imgHeight = img.height;
            const imgHeight = img.getAttribute('height');
            const imgWidth = img.getAttribute('width');
            // 遍历所有的area元素，获取到对应的href值
            const newImg = ahtml.value.querySelector('img[usemap=' + `"#${mapName}"` + ']');
            const newImgWidth = newImg.clientWidth;
            const newImgHeight = newImg.clientHeight;
            const widthRatio = Number(newImgWidth / imgWidth).toFixed(2);
            const heightRatio = Number(newImgHeight / imgHeight).toFixed(2);
            areas.forEach(area => {
              // 根据img按newimg的比例缩放area的坐标
              const coords = area.coords.split(',');
              const adjustedCoords = coords.map((value, index) => {

                const adjustedValue = index % 2 === 0 ? value * widthRatio : value * heightRatio;
                // 将每一个调整后的坐标值四舍五入到指定的小数位数
                return Number(adjustedValue.toFixed(2));
              }
              );
              area.style.backgroundColor = 'red';
              // 判断area.href有值且是已/开头
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${'/' + locale}${href}`);
              }
              area.coords = adjustedCoords;
            });
          } else if (index !== -1 && alt.indexOf('autosize0') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            areas.forEach(area => {
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${'/' + locale}${href}`);
              }
            });
          }
        });
        const videos = ahtml.value?.querySelectorAll('video');
        videos?.forEach((video) => {
          if (video.autoplay) {
            video.play();
          }
        });
      } catch (e) {
        console.log('e', e);
      }
    });
    return {
      Artcle: computed(() => artcle?.value),
      markedGet,
      bgColor,
      fontColor,
      $storeConfig: context?.root.$options.$storeConfig,
      ahtml,
      configs
    };
  }
};
